import { NgOptimizedImage } from "@angular/common";
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { BenefitsListComponent } from "@shared/components/molecules/benefits-list/benefits-list.component";
import { ReferencesListComponent } from "@shared/components/molecules/references-list/references-list.component";
import { IconComponent } from "@shared/components/atoms/icon/icon.component";
import { FooterInfoLinksComponent } from "@shared/components/molecules/footer-info-links/footer-info-links.component";
import { PAYMENT_METHOD_LOGO_SET } from "@shared/constants/payment-logo-set";
import { SHIPPING_OPTIONS_LOGO_SET } from "@shared/constants/shipping-logo-set";
import { TranslatePipe } from "@ngx-translate/core";
import { ZohoLivechatButtonComponent } from "@shared/components/molecules/zoho-livechat-button/zoho-livechat-button.component";

@Component({
  selector: "app-main-footer",
  imports: [
    BenefitsListComponent,
    ReferencesListComponent,
    IconComponent,
    FooterInfoLinksComponent,
    TranslatePipe,
    ZohoLivechatButtonComponent,
    NgOptimizedImage,
  ],
  templateUrl: "./main-footer.component.html",
  styleUrl: "./main-footer.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainFooterComponent {
  readonly paymentMethodLogoPaths = PAYMENT_METHOD_LOGO_SET;
  readonly shippingServiceLogoPaths = SHIPPING_OPTIONS_LOGO_SET;
  readonly currentYear = new Date().getFullYear();
}
